module.exports = __webpack_public_path__ + "rgfw2.png?0591036a8fc3c729685aae7dcb042250";


//////////////////
// WEBPACK FOOTER
// ./static/assets/rgfw2.png
// module id = 253
// module chunks = 0